import { isLoggedInUser } from "../helpers";

export const Vue = window['Vue'];
export const VeeValidate = window['VeeValidate'];
export const mixpanel = window['mixpanel'];
export const isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
  || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))

export const webClientID = "0417b144-0f3f-11e8-87cc-0242ac110002";

export const socialPrefix="/api/social-svc/2.0/";
export const orderApiPrefix = "/api/order-svc/2.0/";
export const apiPrefix = "/2.0/";
export const authPrefix = '/api/auth-svc/1.0/';
export const tripPrefix = "/api/trip-svc/1.0/";
export const deliveryService = "/api/delivery-svc/2.0/";
export const basePrefix = "/api/";
export const steeringService = "/api/steering/restaurant/v1/";

export const payfortPrefix = "https://checkout.PayFort.com/"
export const payfortPaymentPrefix = "https://paymentservices.payfort.com/"
export const payfortAccessCode = "P2yn8MCE1tMDD8CPHUho";
export const payfortMerchantIdentifier = "bblRFTgE";

// export const payfortPrefix = "https://sbcheckout.payfort.com/"
// export const payfortPaymentPrefix = "https://sbpaymentservices.payfort.com/"
// export const payfortAccessCode = "KM2UuPvEprTanpu9pnrP";
// export const payfortMerchantIdentifier = "gEqYOPAU";
// export const orderApiPrefix = "https://test01.elmenus.com/api/order-svc/2.0/";
// export const apiPrefix = "https://test01.elmenus.com/2.0/";
// export const socialPrefix ="https://test01.elmenus.com/api/social-svc/2.0/";
// export const authPrefix = 'https://test01.elmenus.com/api/auth-svc/1.0/';
// export const tripPrefix = "https://test01.elmenus.com/api/trip-svc/1.0/";
// export const deliveryService = "https://test01.elmenus.com/api/delivery-svc/2.0/";
// export const basePrefix = "https://test01.elmenus.com/api/";
// export const steeringService = "https://test01.elmenus.com/api/steering/restaurant/v1/";


//export const interComeId = "fwmexksi"; // testing
 export const interComeId = "u3ctplmf"; //production

var uniqid = require('uniqid');


export const egypt = {
  lat: 30.06263,
  lon: 31.24967
}
export const cookies = {
  auth: 'Authorization',
  refreshToken: 'webRefreshToken',
  tokenExpiry: 'webAccessTokenExpiry',
  lang: 'lang',
  xTracking: 'X-Tracking',
  userArea: 'userArea',
  userCity: 'userCity',
  userZone: 'userZone',
  deliveryTour: 'deliveryTour',
  restaurantTour: 'restaurantTour',
  FOPModal: 'FOPModal',
  lat: 'lat',
  long: 'long',
  groupOrderingWalkThrow: 'groupOrderingWalkThrow',
  groupOrderingWalkThrowDate: 'groupOrderingWalkThrowDate',
  groupOrderingWalkThrowCount: 'groupOrderingWalkThrowCount',
  hygiene: 'hygiene',
  company:'Company',
};

export const websitePages = {
  dineout: {
    topRestaurants: 'top-restaurants',
    newRestaurants: 'new-restaurants',
  }
}

export const lang = {
  ar: 'AR',
  en: 'EN'
}

export const filters = {
  features: 'features',
  orderingEnabled: 'order-online'
}

export const photosUrlEnum = {
  version: {
    normal: 'Normal',
    thumbnail: 'Thumbnail',
  },
  ext: {
    WEBP: 'webp',
    JPG: 'jpg'
  },
  placeholders: {
    ext: '{{PHOTO_EXTENSION}}',
    version: '{{PHOTO_VERSION}}'
  }
}

export const servicesURL = {
  addUserLocationOnTrip:(tripUUID)=>`${tripPrefix}trip/${tripUUID}/customer/location`,
  TRIPCOMPACT: (tripUUID) => `${tripPrefix}/trip/${tripUUID}/compact`,
  tinderDishes: (zone,page,size)=>`${deliveryService}dish-discovery?page=${page}&pageSize=${size}&zone=${zone}`,
  dynamicSection: (params) => `${apiPrefix}discovery/delivery/dynamic-sections?${params}`,
  announcements: (area,zone)=>`${apiPrefix}discovery/delivery/announcements?area=${area}&zone=${zone}`,
  getDishFeedback: `${socialPrefix}order-review`,
  postDishFeedback(uuid) {
    return `${socialPrefix}order-review/${uuid}`
  },
  dismissDishFeedback(uuid) {
    return `${socialPrefix}order-review/${uuid}/dismiss`
  },

  chat: `${apiPrefix}profile/intercom-verification/web`
  ,
  searchPage(searchInput) {
    return `/search-${searchInput}`;
  },
  locationDetect(lat, long) {
    return `${apiPrefix}location/detect?lat=${lat}&lon=${long}`;
  },
  getZonePolygon(zoneUuid) {
    return `${apiPrefix}location/polygon?zoneUUID=${zoneUuid}`;
  },
  restaurant: {

    getRestaurant(shortcode, params) {
      return `${apiPrefix}restaurant/${shortcode}?${params}`;
    },
    getRelatedRestaurants(params) {
      return `${apiPrefix}discovery/delivery/related-restaurants?${params}`;

    },
    getBranchMenu: (branchShortCode: string, companyId: string) =>
      `${steeringService}branches/${branchShortCode}/menu${
        companyId ? "?companyId=" + companyId : ""
      }`,
    search(params) {
      return `${steeringService}restaurants/search?${params}`;
    },
    autocomplete(params) {
      return `${steeringService}restaurants/search-autocomplete?${params}`;
    },
    item: {
      getDetails: (branchShortCode: string, menuItemId: string) =>
        `${steeringService}branches/${branchShortCode}/items/${menuItemId}`,
      like(itemUUID) {
        return `${apiPrefix}restaurant/item/${itemUUID}/like`;
      },
      reset(itemUUID) {
        return `${apiPrefix}restaurant/item/${itemUUID}/reset`;
      }
    },
    photos(restSortCode, params) {
      return `${apiPrefix}restaurant/${restSortCode}/photo?${params}`;
    },
    call(bUUID: string) {
      return `${apiPrefix}branch/${bUUID}/call`;
    },
    reviews(restSortCode, params) {
      return `${apiPrefix}restaurant/${restSortCode}/review?${params}`;
    },
    addReview: `${apiPrefix}review`,
    photoUpload: `${apiPrefix}photo-upload`,
    getCompactBranches (restSortCode : string) {
      return `${steeringService}/restaurants/${restSortCode}/branches/compact`;
    },
  },
  review: {
    markAsHelpful(reviewUUID) {
      return `${apiPrefix}review/${reviewUUID}/helpful`
    }
  },
  photos: {
    photo(uuid) {
      return `${apiPrefix}photo/${uuid}`;
    }
  },
  order: {
    post: `${apiPrefix}order`,
    lastOrder: `${apiPrefix}order/last-active`,
    orderState(uuid) {
      return `${orderApiPrefix}order/${uuid}/state`;
    },
    allOrdersState: `${apiPrefix}order/current`,
    selectedOrderStateDetails: (uuid: string) => `${orderApiPrefix}order/${uuid}/state/details`,
    getMyOrderPeopleSplit: (uuid: string) => `${apiPrefix}order/${uuid}/split-view`,

    orderDelivered: (uuid: string) => `${apiPrefix}order/${uuid}/delivered`,
    cancel(uuid) {
      return `${apiPrefix}order/${uuid}/cancel`;
    },
    promo(bUUID, code) {
      return `${apiPrefix}promo?branch=${bUUID}&code=${code}`;
    },
    getMyOrders: `${orderApiPrefix}order/my-orders`,
    getSpecificOrder: (OrderUUID) => `${orderApiPrefix}order/${OrderUUID}/details`,
    reOrder: (OrderUUID) => `${apiPrefix}basket/from-order/${OrderUUID}`,
    updateOrder: {
      address: (OrderUUID) => `${orderApiPrefix}order/${OrderUUID}/address`,
      payment: (OrderUUID) => `${orderApiPrefix}order/${OrderUUID}/payment`
    },
    resumeOrder: (OrderUUID) => {
      const time = new Date().getTime();
      return `${orderApiPrefix}order/${OrderUUID}/resume?time=${time}`
    }
  },
  trip: {
    getDriverLocation: (tripUUID) => `${tripPrefix}trip/${tripUUID}/location`,
  },
  gifting:`${orderApiPrefix}promo/gift`,
  basket: {
    unlock: (groupBasketUUID) => `${apiPrefix}basket/group/${groupBasketUUID}/unlock`,
    leave: (groupBasketUUID) => `${apiPrefix}basket/group/${groupBasketUUID}/leave`,

    create: `${apiPrefix}basket`,
    details: `${apiPrefix}basket/details`,
    summary: `${apiPrefix}basket/summary`,
    compact: `${apiPrefix}basket/compact`,
    delete: `${apiPrefix}basket`,
    promo: `${apiPrefix}basket/promo`,
    wallet: `${apiPrefix}basket/wallet`,
    removeItem: (basketItemUUID) => `${apiPrefix}basket/item/${basketItemUUID}`,
    removeBulk: `${apiPrefix}basket/item/bulk`,
    item: `${apiPrefix}basket/item`,
    edit: (BasketItemUUID) => `${apiPrefix}basket/item/${BasketItemUUID}`,
    adresses: `${apiPrefix}basket/address`,
    placeOrder: (placeId) => `${placeId ? orderApiPrefix + 'basket/order?placeId=' + placeId : orderApiPrefix + 'basket/order'}`,
    payment: `${apiPrefix}basket/payment`,
    state: `${apiPrefix}basket/state`,
    deliveryTime: `${apiPrefix}basket/delivery-time`,
    group: {
      start: `${apiPrefix}basket/group`,
      convert: `${apiPrefix}basket/convert-to-group`,
      summary: (BasketUUID) => `${apiPrefix}basket/group/${BasketUUID}/summary`,
      item: (BasketUUID) => `${apiPrefix}basket/group/${BasketUUID}/item`,
      updateItem: (BasketUUID, BasketItemUUID) => `${apiPrefix}basket/group/${BasketUUID}/item/${BasketItemUUID}`,
      join: (BasketUUID) => `${apiPrefix}basket/group/${BasketUUID}/join`,
      link: (BasketUUID) => `${apiPrefix}basket/group/${BasketUUID}/link`
    }
  },
  settings: `${apiPrefix}settings`,
  auth: {
    post: `${apiPrefix}auth`
  },
  guest: {
    post: `${authPrefix}auth/via/guest`
  },
  user: {
    isUser: `${apiPrefix}user/is-user`,
    notifications(params) {
      return `${apiPrefix}notification?${params}`;
    },
    forgetPassword: (email) => `${authPrefix}auth/email/${email}`,
		changePassword: `${authPrefix}password`,
    login: `${authPrefix}auth`,
    register: `${authPrefix}registeration/email`,
  },
  creditCards: {
    getCards: `${apiPrefix}card`,
    prepAddCard: `${apiPrefix}card/generate-card-signature`,
    trustCard(uuid) {
      return `${apiPrefix}card/${uuid}/trust`;
    },
    generateSignature: `${apiPrefix}card/generate-response-signature`,
    verifyCard(uuid) {
      return `${apiPrefix}card/${uuid}/verify`;
    },
    addCard: `${payfortPrefix}FortAPI/paymentPage`,
    authorizCard: (cardUUID) => `${apiPrefix}card/${cardUUID}/adding-verification`
  },
  profile: {
    userProfile: `${apiPrefix}profile`,
    addAddress: `${apiPrefix}profile/address`,
    getAllAddresses: `${apiPrefix}profile/address`,
    deleteAddress(uuid) {
      return `${apiPrefix}profile/address/${uuid}`;
    },
    editAddress(uuid) {
      return `${apiPrefix}profile/address/${uuid}`;
    },
    setDefaultAddress(uuid) {
      return `${apiPrefix}profile/address/${uuid}/set-default`;
    },
    sendVerification(uuid) {
      return `${apiPrefix}profile/address/${uuid}/phone-number/send-verification`;
    },
    verifyNumber(uuid) {
      return `${apiPrefix}profile/address/${uuid}/phone-number/verify-number`;
    },
    changeEmail: `${apiPrefix}profile/email`,
    promoBanner: (areauuid, numberOfOrders) => `${apiPrefix}discovery/delivery/promo?areaUUID=${areauuid}&numberOfOrders=${numberOfOrders}`,
    setFreshChatRestoreId: `${apiPrefix}profile/freshdesk-identifier`,
  },
  fb: {
    login: `${authPrefix}registeration/facebook`
  },
  google: {
    login: `${authPrefix}registeration/google/web`
  },
  discovery: {
    delivery: {
      lookups(area) {
        return `${apiPrefix}discovery/delivery/categories?area=${area}`;
      },
      search(params) {
        return `${apiPrefix}discovery/delivery/search?includeDiscount=true&${params}`;
      },// params:zone,area,category,orderingEnabled,onlinePayment,quickDelivery,compact,page,pageSize,
      offers(area, zone, company) {
        const lat = getCookie("lat");
        const lon = getCookie("long");
        return `${apiPrefix}discovery/delivery/offers?includeDiscount=true&area=${area}${zone ? '&zone=' + zone : ''}${company ? '&companyId=' + company : ''}${lat && lon ? '&lat=' + lat + '&lon=' + lon : ''}`;

      },
      allOffers(params: string) { // params: area,category,orderingEnabled,onlinePayment,quickDelivery,compact,page,pageSize 
        return `${apiPrefix}discovery/delivery/get-all-offers${params}`;
      },
      cvm: (promoName, area, zone, page) => `${apiPrefix}discovery/delivery/search?includeDiscount=true&area=${area}${zone ? '&zone=' + zone : ''}&promoName=${promoName}&orderingEnabled=true&promoEnabled=true&openNow=true&page=${page}&pageSize=12`,
    },
    dineout: {
      index: `${apiPrefix}discovery/dineout`,
      topRestaurants(params) {
        return `${apiPrefix}discovery/dineout/top?${params}`;
      }, // params: city, area, lat, lon, openNow, category, feature, compact, page, pageSize, sort, mood, allMoods, allCategories
      hiddenRestaurants(params) {
        return `${apiPrefix}discovery/dineout/hidden?${params}`;
      },
      newRestaurants(params) {
        return `${apiPrefix}discovery/dineout/new?${params}`;
      },
      getRestaurants(params) {
        return `${apiPrefix}discovery/dineout/restaurant?${params}`;
      }
    },
  },
  timeline: {
    reviews: (userUUID, params) => `${apiPrefix}timeline/${userUUID}/review?${params}`
  },
  topup: `${basePrefix}wallet-svc/wallet/topup`
};

export const analyticsEvents = {

  loging: {
    category: 'Logging',
    events: {
      google: 'Login_with_Google',
      facebook: 'Login_with_Facebook',
      email: 'Login_with_Email',
      forget: 'Forgot Password',
      create: 'Create Account'
    },
    labels: {
      email: (email) => `User Email: ${email}`
    }
  },
  restaurant: {
    category: 'Restaurant',
    events: {
      view: 'Screen_View_Restaurant',
      callModal: 'Open_call_modal',
      call: 'Action_Call_Restaurant',
      open_item_details: 'Action_Open_Item_Details',
      searchMenu: 'Action: Search in menu',
      searchedItem: 'Action: Clicked on searched menu item'
    },
    labels: {
      enabledState: (onlineOrdering) => `${onlineOrdering ? 'Enabled for online ordering' : 'Non Enabled for online ordering'}`,
      sourceScreen: (sourceScreen) => `Source Screen: ${sourceScreen}`,
      keyword: (keyword) => `Keyword: ${keyword}`,
      selectedItem: (keyword) => `Item name: ${keyword}`
    },
    value: {
      enabled: 1,
      nonEnabled: 0
    }
  },
  discovery: {
    categories: {
      delivery: 'Discovery Delivery',
      dineOut: 'Discovery Dineout',
      search: 'Restaurant Search'
    },
    events: {
      view: 'Screen_Discovery_Delivery',
      dish: 'Action_Dish_Discovery',
      onlineOrdering: 'enable Online ordering',
      sort: 'Sort',
      filter: 'Filter',
      autoComplete: 'Auto Complete',
      searchButton: 'Click on Search Results',
      selectCompany: 'Click on Select Company',
      chooseCompany: 'Choose Company',
      chooseCompanyError: 'Choose Company Error',
      tastyOffers: 'Tasty offers'
    },
    labels: {
      area: (area) => `Area: ${area}`,
      dishtag: (tag) => `Tag: ${tag}`,
      keyword: (keyword) => `Keyword: ${keyword}`,
      company: (company) => `Company: ${company}`,
      companyOffers: (count) => `Company offers count: ${count}`
    }

  },
  ordering: {
    category: 'Ordering',
    events: {
      createBasket: 'Action_Create_Basket',
      createGroup: 'Action_Start_Group',
      deleteBasket: (isGroup) => `Action_Delete_${isGroup ? 'Group' : 'Basket'}`,
      addItem: 'Action_Add_Item_to_Basket_Success',
      addItemError: 'Action_Add_Item_to_Basket_Error',
      genericError: 'Generic Error',
      editItem: 'Action_Edit_Item',
      removeItem: 'Action_Remove_Item',
      removeErroredItems: 'Remove unavailable items from Basket',
      joinGroup: 'Action_Join_Group',
      convertToGroup: 'Action_Convert_Basket_to_Group',
      leaveGroup: 'Action_Leave_Group',
      shareGroup: 'Action_Share_Group',
      unlockGroup: 'Action_Unlock_Group',
      peopleView: 'Open People View',
      proceedToCheckout: 'Action_Proceed_to_Checkout',
      addPromo: 'Action_Redeem_Promo',
      companyOrder: 'Company Order',
      placeOrder: 'Action_Place_Order_Success',
      placeOrderError: 'Action_Place_Order_Error',
      promoError: 'Action_Redeem_Promo_Error',
      deleteBasketError: 'Action_Delete_Basket_Error',
      joinGroupError: 'Action_Join_Group_Error',
      createBasketError: 'Action_Create_Basket_Error',
      startGroupError: 'Action_Start_Group_Error',
      unlockGroupError: 'Action_Unlock_Group_Error',
    },
    labels: {
      firstOrder: (firstOrder) => `First Order: ${firstOrder ? 'yes' : 'no'}`,
      basketUUID: (basketUUID) => `${basketUUID}`,
      promoName: (promoName) => `${promoName}`,
      errorType: (errorType) => `Error Type: ${errorType}`,
      companyName: (company) => `Company: ${company}`
    }
  },
  myOrders: {
    category: 'My Orders',
    events: {
      cancelOrder: 'Cancel Order',
      groupOrder: 'Open my group order',
      peopleView: 'Open people view',
      callDriver: 'Call Driver'
    },
    labels: {
      trip: (driver, tripStatus) => `Driver: ${driver}, Trip Status: ${tripStatus}`
    }
  }
}
export const googleAnalyticsEvents = {
  login: {
    category: 'login',
    events: {
      facebook: {
        event: 'facebook_login',
        label: 'Login with Facebook'
      },
      email: {
        event: 'email_login',
        label: 'Login with Email'
      },
      forget: {
        event: 'forgot_password',
        label: 'Forgot Password'
      },
      create: {
        event: 'create_account',
        label: 'Create Account'
      }
    }
  },
  delivery: {
    category: 'delivery',
    events: {
      dish: {
        event: 'dish_discovery',
        label: 'Dish Discovery'
      },
      online_ordering_toggle: {
        event: 'online_ordering_toggle',
        label: 'Online Ordering Toggle'
      },
      sort: {
        event: 'sort',
        label: 'sort'
      },
      filter: {
        event: 'filter',
        label: 'filter'
      },
      delivery: {
        event: 'delivery',
        label: 'delivery page'
      }

    }
  },
  search: {
    category: 'search',
    events: {
      restaurant_search: {
        event: 'restaurant_search',
        label: 'Restaurant Search'
      }
    }
  },
  restaurant: {
    category: 'restaurant',
    events: {
      view_with_online_ordering: {
        event: 'view_with_online_ordering',
        label: ''
      },
      call_enabled_restaurant: {
        event: 'Call Enabled Restaurant',
        label: 'call_enabled_restaurant'
      },
      closed_zone_prompt: {
        event: 'Closed Zone Prompt',
        label: 'closed_zone_prompt'
      },
      view_source: {
        event: 'view_source',
        label: ''
      },
      item_details_online_ordering: {
        event: 'item_details_online_ordering',
        label: 'Item Details Online Ordering'
      },
      item_details_no_online_ordering: {
        event: 'item_details_no_online_ordering',
        label: 'Item details no online ordering'
      },
      add_first_item: {
        event: 'add_first_item',
        label: 'add first item'
      },
      add_item_to_basket: {
        event: 'add_item_to_basket',
        label: 'add item to basket'
      },
      add_zone: {
        event: 'add_zone',
        label: 'add zone'
      },
      change_zone: {
        event: 'change_zone',
        label: 'change zone'
      },
      restaurant_info: {
        event: 'restaurant_info',
        label: 'Restaurant info'
      },
      view_restaurant: {
        event: 'view_restaurant',
        label: 'View Restaurant'
      },
      view_restaurant_enabled: {
        event: 'view_restaurant_enabled',
        label: 'View Restaurant that is enabled for online ordering'
      },
      call_restaurant: {
        event: 'call_restaurant',
        label: 'Call Restaurant '
      },
      fop_prompt: {
        event: 'fop_prompt',
        label: 'FOP Prompt '
      },
    }
  },
  basket: {
    category: 'basket',
    events: {
      edit_item: {
        event: 'edit_item',
        label: 'Edit Item'
      },
      proceed_to_checkout: {
        event: 'proceed_to_checkout',
        label: 'Proceed to Checkout'
      },
      generic_error: {
        event: 'Error: Generic Error',
        label: 'Error: Generic Error'
      },
      add_item_error: {
        event: 'Error: Add Item Error',
        label: 'Error: Add Item Error'
      },

      create_basket: {
        event: 'Action: Create Basket',
        label: (basketType) => { return "Restaurant Name: " + basketType }
      },

    }
  },
  groups: {
    category: 'Groups',
    events: {
      share_group: {
        event: 'Action: Share Group',
        label: (basketType) => { return "Restaurant Name: " + basketType }
      },

      cancel_group: {
        event: 'Action: Cancel Group',
        label: (basketType) => { return "Restaurant Name: " + basketType }
      },
      leave_group: {
        event: 'Action: Leave Group',
        label: (basketType) => { return "Restaurant Name: " + basketType }
      },
      convert_group: {
        event: 'Action: Convert Basket to Group',
        label: (basketType) => { return "Restaurant Name: " + basketType }
      },
      start_group: {
        event: 'Action: Start Group',
        label: (basketType) => { return "Restaurant Name: " + basketType }
      },
      unlock_group: {
        event: 'Action: Unlock Basket',
        label: (basketType) => { return "Restaurant Name: " + basketType }
      },
      people_view: {
        event: 'Action: View People View',
        label: (basketType) => { return "SourceScreen: " + basketType }
      },
    }

  },
  checkout: {
    category: 'checkout',
    events: {
      final_screen: {
        event: 'final_screen',
        label: 'Final screen'
      },
      pin_map: {
        event: 'pin_map',
        label: 'Pin map'
      },
      add_address: {
        event: 'add_address',
        label: 'Add address'
      },
      add_address_success: {
        event: 'add_address_success',
        label: 'Add address success'
      },
      phone_verification: {
        event: 'phone_verification',
        label: 'Phone verification'
      },
      phone_verified_success: {
        event: 'phone_verified_success',
        label: 'Phone verified success'
      },
      promo_code: {
        event: 'promo_code',
        label: 'Promo code'
      },
      promo_code_success: {
        event: 'promo_code_success',
        label: 'Promo code success'
      },
      place_order: {
        event: 'Action: Place Order - Success',
        label: (basketType) => { return "Basket Type: " + basketType }
      },
      place_order_click: {
        event: 'Action: Place Order',
        label: (basketType) => { return "Basket Type: " + basketType }
      },


    }
  },
  tracking: {
    category: 'tracking',
    events: {
      cancel_order: {
        event: 'cancel_order',
        label: 'Cancel order'
      }
    }
  },
  myOrders: {
    category: 'My orders/Groups',

  }

};
export const mixpanelEvents = {
  viewRestaurant: {
    event: 'Screen: View Restaurant',
    properties: (
      restaurantName,
      sourceScreen,
      paymentFlag,
      orderingFlag,
      promoFlag,
      area,
      areaEnabledFlag
    ) => {
      return {
        "Restaurant Name": restaurantName,
        "SourceScreen": sourceScreen,
        "Payment Flag": paymentFlag,
        "Ordering Flag": orderingFlag,
        "Promo Flag": promoFlag,
        "Area": area,
        "Area Enabled Flag": areaEnabledFlag
      }
    }
  },
  restaurantTextMenu: {
    event: 'Screen: Restaurant Text Menu',
    isPushed: false,
    properties: (
      restaurantName,
      area
    ) => {
      return {
        "Restaurant Name": restaurantName,
        "Area": area
      }
    }
  },
  callRestaurant: {
    event: 'Action: Call Restaurant',
    properties: (
      restaurantName,
      area,
      areaEnabledFlag
    ) => {
      return {
        "Restaurant Name": restaurantName,
        "Area": area,
        "Area Enabled Flag": areaEnabledFlag
      }
    }
  },
  clickRestaurant: {
    event: 'Action: Clicked on Restaurant',
    properties: (
      restaurantName,
      area,
      position,
      sourceScreen
    ) => {
      return {
        "Restaurant Name": restaurantName,
        "Area": area,
        "Position": position,
        "SourceScreen": sourceScreen
      }
    }
  },
  openItemDetails: {
    event: 'Action: Open Item Details',
    properties: (
      restaurantName,
      area,
      restaurantOrderingFlag
    ) => {
      return {
        "Restaurant Name": restaurantName,
        "Restaurant Ordering Flag": restaurantOrderingFlag,
        "Area": area,
      }
    }
  },
  addItemToBasket: {
    event: 'Action: Add Item to Basket',
    properties: (
      isGuest
    ) => {
      return {
        "Guest Flag": isGuest,

      }
    }
  },
  addItemToBasketSuccess: {
    event: 'Action: Add Item to Basket - Success',
    properties: (
      restaurantName,
      area,
      numberOfItemsAdded,
      zonePromptFlag,
      basketType,
      userType
    ) => {
      return {
        "Restaurant Name": restaurantName,
        "Area": area,
        "No. of items added": numberOfItemsAdded,
        "Zone Prompt Flag": zonePromptFlag,
        "Basket Type": basketType,
        "User Type": userType
      }
    }
  },
  firstItemPrompt: {
    event: 'Add First Item Prompt',
    properties: (
      restaurantName
    ) => {
      return {
        "Restaurant Name": restaurantName
      }
    }
  },
  mainCheckoutScreen: {
    event: 'Screen: Main Checkout Screen',
    properties: (
      restaurantName,
      area,
      basketType
    ) => {
      return {
        "Restaurant Name": restaurantName,
        "Area": area,
        "Basket Type": basketType
      }
    }
  },
  addAddress: {
    event: 'Screen: Add Address',
    properties: (
      sourceScreen
    ) => {
      return {
        "SourceScreen": sourceScreen
      }
    }
  },
  redeemPromo: {
    event: 'Action: Redeem Promo',
    properties: (
      promoName
    ) => {
      return {
        "Promo Name": promoName
      }
    }
  },
  phoneVerification: {
    event: 'Screen: Phone Verification',
    properties: (
      userNumber
    ) => {
      return {
        "User Number": userNumber
      }
    }
  },
  placeOrder: {
    event: 'Action: Place Order - Success',
    properties: (
      restaurantName,
      paymentType,
      promoName,
      newOrReturning,
      orderValue,
      addressArea,
      promoValue,
      promoDiscount,
      isFirstOrder,
      basketType
    ) => {
      return {
        "Restaurant Name": restaurantName,
        "Payment Type": paymentType,
        "Promo Name": promoName,
        "Order Value": orderValue,
        "Address Area": addressArea,
        "Promo Value": promoValue,
        "Promo Discount": promoDiscount,
        "First Order": isFirstOrder,
        "Basket Type": basketType
      }
    }
  },
  orderRejected: {
    event: 'Action: Order Rejected',
    properties: (
      rejectionReason
    ) => {
      return {
        "Rejection Reason": rejectionReason
      }
    }
  },
  closeZonePrompt: {
    event: 'Action: Close Zone Prompt',
    properties: (
      RestaurantName
    ) => {
      return {
        key: 'Restaurant Name',
        value: RestaurantName
      }
    }
  },
  discoveryDelivery: {
    event: 'Screen: Discovery_Delivery',
    properties: (
      area,
      newOrReturning,
      areaEnabledFlag
    ) => {
      return {
        "Area": area,
        "New/Returning User": newOrReturning,
        "Area Enabled Flag": areaEnabledFlag
      }
    }
  },
  dishDiscovery: {
    event: 'Screen: Dish Discovery',
    properties: (
      dishTag,
      area
    ) => {
      return {
        "Dish tag": dishTag,
        "Area": area
      }
    }
  },
  searchScreen: {
    event: 'Search Screen',
    properties: (
      keyword
    ) => {
      return {
        "Keyword": keyword
      }
    }
  },
  onlineOrderingToggle: {
    event: 'Action: Online Ordering Toggle',
    properties: (
      area
    ) => {
      return {
        "Area": area
      }
    }
  },
  loginFacebook: {
    event: 'Login with Facebook',
    properties: (
      area
    ) => {
      return {
        "Area": area
      }
    }
  },
  loginEmail: {
    event: 'Login with Email',
    properties: (
      email
    ) => {
      return {
        "Email": email
      }
    }
  },
  delivery: {
    event: 'Action: Click on Delivery in Homepage'
  },
  dineout: {
    event: 'Action: Click on Dineout in Homepage'
  },
  loginScreen: {
    event: 'Screen: Login Screen',
    properties: (
      area
    ) => {
      return {
        "Area": area
      }
    }
  },
  viewPeopleView: {
    event: 'Action: View People View',
    properties: (
      sourceScreen
    ) => {
      return {
        "SourceScreen": sourceScreen
      }
    }
  },
  startGroup: {
    event: 'Action: Start Group',
    properties: (
      startPoint,
      restName
    ) => {
      return {
        "Start Point": startPoint,
        "Restaurant Name": restName,
      }
    }
  },
  convertToGroup: {
    event: 'Action: Convert Basket to Group',
    properties: (
      restName
    ) => {
      return {
        "Restaurant Name": restName,
      }
    }
  },
  leaveGroup: {
    event: 'Action: Leave Group',
    properties: (
      restName
    ) => {
      return {
        "Restaurant Name": restName,
      }
    }
  },
  cancelGroup: {
    event: 'Action: Cancel Group',
    properties: (
      restName
    ) => {
      return {
        "Restaurant Name": restName,
      }
    }
  },
  shareGroup: {
    event: 'Action: Share Group',
    properties: (
      userType,
      restName
    ) => {
      return {
        "User Type": userType,
        "Restaurant Name": restName
      }
    }
  },
  createBasket: {
    event: 'Action: Create Basket',
    properties: (
      restName
    ) => {
      return {
        "Restaurant Name": restName
      }
    }
  },
  impression:{
    event:"Impression",
    properties: ({ userId, userName, email },{ hyperlink, position, imageUrl, appSection, sourceScreen, language }, customProps = {}) => {
      return {
        "User ID": userId,
        "User Name": userName,
        "Email": email,
        "Guest Flag": !isLoggedInUser(),
        "Language": language,
        "Hyperlink": hyperlink,
        "Position": position,
        "Image URL": imageUrl,
        "App Section": appSection,
        "SourceScreen": sourceScreen,
        ...customProps
      }
    }
  }
}
export const requestHeaders = {
  clientModel: isMobile ? 'MOBILE_WEB' : 'WEB',
  clientVersion: '5',
  deviceModel: navigator.userAgent
}

export const userType = {
  GUEST : "Guest" 
}

export const setCookie = (cname, cvalue, path, expires: any = `${30 * 86400}`) => {
  document.cookie = cname + "=" + cvalue + ";" + ";path="+path + ";max-age="+expires;
}

export const getCookie = (name) => {
  name = name + "=";
  var arr = document.cookie.split(';');
  for (var i = 0; i < arr.length; i++) {
    var c = arr[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const generateDeviceId = () => {
  if (getCookie('payload')) {
    return getCookie('payload')
  } else {
    let id = uniqid();
    setCookie('payload', id, '');
    return id;
  }
}

export let deviceID = generateDeviceId();

export const setDeviceId = (id, config) => {
	config.headers['X-Device-Id'] = id;
	return config;
}

export var headers = {
  'Content-Type': 'application/json',
  'X-Client-Id': webClientID,
  'lang': getCookie(cookies.lang),
  'Client-Model': requestHeaders.clientModel,
  'Client-Version': requestHeaders.clientVersion,
  'Device-Model': navigator.userAgent,
  'Authorization': `Bearer ${getCookie(cookies.auth)}`,
  'X-Device-Id': deviceID,
  'Device-ID': deviceID,
  'userCompany': getCookie(cookies.company) ? JSON.parse(getCookie(cookies.company)).place_id : '',
  'userZone': getCookie(cookies.userZone),
  'userArea': getCookie(cookies.userArea)
}

if (getCookie('long') && getCookie('lat')) {
  headers['userLong'] = getCookie('long');
  headers['userLat'] = getCookie('lat');
}

export const enum LocalStorageKeys {
  Restaurant_Source_Screen = "restaurant-source-screen",
  Segments_Setup = "segments-setup",

}

export const enum SourceScreens {
  Autocomplete = "autocomplete",
  SearchPage = "search",
}

export const enum DynamicCardTypes {
  Offers = "offers",
  Normal = "normal",
  FlashOffers = "flashOffers",
}
export const enum OffersTypes {
  Company = "COMPANY",
  Default = "DEFAULT",
  Flash = "FLASH",
}